// import { Theme, createStyles, makeStyles } from '../../../UI/MaterialUI'

import { Theme, createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme: Theme) =>
  createStyles({
    speakTitle: {
      '@global': {
        span: {
          fontFamily: 'Lato'
        }
      }
    },
    speakContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '2rem',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '0.5rem'
      }
    },
    subtitle: {
      fontSize: 20,
      fontFamily: 'LatoNormal !important',
      width: '70%',
      margin: '.5rem 0',
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        justifyContent: 'center'
      }
    },
    containerDetail: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        justifyItems: 'center',
        alignItems: 'center'
      }
    },
    phone: {
      color: 'var(--bosscat-blue-600)',
      fontFamily: 'Lato',
      fontSize: '20px'
    },
    root: {
      display: 'grid',
      gridAutoRows: 'min-content min-content auto',
      height: '100%',
      width: '100%',
      margin: 0
    },
    filters: {
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        margin: 0,
        padding: '0 !important'
      }
    },
    tableContainer: {
      border: '2px solid var(--border-color)',
      borderRadius: 14,
      '@global': {
        '.MuiTable-root': {
          height: '100%'
        }
      },
      [theme.breakpoints.down('lg')]: {
        border: '0'
      }
    },
    table: {
      paddingRight: '24px',
      [theme.breakpoints.down('lg')]: {
        paddingRight: '0px'
      }
    },
    tableComponent: {
      position: 'relative',
      borderStyle: 'solid',
      borderWidth: 2,
      borderColor: theme.palette.grey[200],
      borderRadius: 12
    },
    pageChange: {
      position: 'absolute',
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 5,
      background: 'rgba(0,0,0,0.02)'
    },
    button: {
      width: '80%',
      height: '32px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-green-600)',
      borderRadius: 8,
      '&:hover': {
        backgroundColor: 'var(--bosscat-green-700)'
      }
    },
    title: {
      fontFamily: 'LatoNormal',
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '16px'
    },
    description: {
      fontFamily: 'LatoNormal',
      fontWeight: 'normal',
      fontSize: '12px'
    },
    row: {
      '&:hover': {
        backgroundColor: 'var(--row-focus)'
      }
    },
    cellHead: {
      backgroundColor: 'var(--background-color-secondary)',
      color: 'var(--head-text-color)',
      borderWidth: 0,
      fontFamily: 'Lato',
      fontSize: '16px',
      padding: '.5rem .25rem'
    },
    cell: {
      fontFamily: 'LatoNormal',
      fontWeight: 400,
      fontSize: 18,
      borderWidth: 1,
      borderRight: '2px solid var(--border-color)',
      borderTop: '2px solid var(--border-color)',
      padding: '.5rem .25rem',
      '@global': {
        '.MuiTypography-root': {
          fontFamily: 'LatoNormal'
        },
        '.MuiFormControl-root': {
          width: '100%'
        },
        '.MuiInput-input': {
          fontFamily: 'LatoNormal'
        },
        '.MuiInputBase-root': {
          height: 'fit-content !important'
        },
        '.MuiInput-underline.Mui-error:after': {
          display: 'none'
        },
        '.imagePicker': {
          width: '40px',
          height: '40px !important'
        },
        '.imagePicker--image': {
          width: '40px',
          height: '40px !important'
        }
      }
    },
    cellMuted: {
      '@global': {
        '.MuiTypography-root': {
          color: 'var(--placeholder-color)'
        }
      }
    },
    noItemContainer: {
      display: 'flex'
    },
    status: {
      textTransform: 'uppercase',
      fontSize: '16px'
    },
    tableSortLabel: {
      height: 'inherit !important',
      color: 'var(--head-text-color) !important',
      '&:hover': {
        color: 'var(--head-text-color)'
      }
    },
    statusSelect: {
      '& li:first-child': {
        '&:after': {
          content: '""',
          display: 'block',
          borderBottom: '2px solid var(--black-color)',
          borderRadius: '8px',
          transform: 'translateY(12px)',
          width: '100%'
        }
      }
    },
    expectedDeliveryLabel: {
      color: 'var(--expired-color)'
    },
    valueComponents: {
      display: 'grid',
      paddingRight: '12px !important',
      gridTemplateColumns: 'repeat(5, 1fr)',
      flexWrap: 'wrap',
      [theme.breakpoints.down('lg')]: {
        margin: 0,
        padding: '0 !important',
        marginTop: '1rem'
      }
    },
    valueItem: {
      gridColumn: 'span 1',
      [theme.breakpoints.down('lg')]: {
        gridColumn: 'span 2'
      },
      [theme.breakpoints.down('sm')]: {
        gridColumn: 'span 5'
      }
    },
    tableOff: {
      position: 'relative',
      borderStyle: 'solid',
      borderWidth: 0,
      backgroundColor: 'transparent',
      borderRadius: 0,
      boxShadow: 'none',
      '@global': {
        '> .MuiGrid-root': {
          width: '100%',
          margin: 'auto'
        }
      }
    },
    createAccount: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '8px',
      margin: '8px 0',
      justifyContent: 'flex-start',
      border: '2px solid #0071A3',
      padding: '8px'
    },
    icon: {
      width: '30px',
      height: '30px',
      marginRight: '10px'
    },
    addItem: {
      width: '185px',
      height: '58px',
      textTransform: 'none',
      color: 'var(--bosscat-blue-600)',
      border: '2px solid var(--bosscat-blue-600)',
      backgroundColor: 'transparent',
      borderRadius: 8,
      '&:hover': {
        backgroundColor: 'var(--bosscat-blue-600)',
        color: 'var(--white-color)'
      },
      [theme.breakpoints.down('sm')]: {
        width: '94%',
        margin: '16px'
      }
    },
    phoneButton: {
      margin: '5px 0px 10px 0px',
      width: '100%',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-green-600)',
      borderRadius: 8
    },
    inputsItem: {
      margin: '6px 0px'
    },
    titleItem: {
      fontSize: '18px',
      fontFamily: 'LatoNormal'
    },
    space: {
      minWidth: '48px',
      minHeight: '54px',
      padding: '12px'
    },
    subtitleContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    label: {
      fontSize: '18px',
      fontFamily: 'LatoBlack !important',
      color: "#0B060F",
      marginBottom: "16px"
    }
  })
)
